module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_34.250bf15f.jpg";